import Vue from 'vue';
// import Moment from 'moment';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    getCategoryConfig: function () {
        //var timestamp = Moment().unix();
        var url = `${this.config().bzbsBlobUrl}/cpf/config/cpf_passcode_cat.json`;
        return BzbsApi.connectBzbsGetBlob(url);
    },

    getSurpriseConfig: function () {
        // var url = `${this.config().bzbsBlobUrl}/cpf/config/surprisebox`;
        var url = `${this.config().bzbsBlobUrl}/webconfig/cpf/surprisebag/surprisebox`;
        return BzbsApi.connectBzbsGetBlob(url);
    },

    getSurpriseBagImg: function () {
        var url = `${this.config().bzbsBlobUrl}/webconfig/cpf/surprisebag/SurpriseBagImg.json`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGetBlob(url).then((res) => {
                var data = res.data.img;
                var img = this.replaceImageEnvironmentPath(data);
                resolve(img)
            }).catch((error) => {
                reject(error);
            });
        });
    },

    replaceImageEnvironmentPath: function (url) {
        return url.replace('{blob}', `${this.config().bzbsBlobUrl}`);
    },

    getHoroscopeConfig: function () {
        //var timestamp = Moment().unix();
        var url = `${this.config().bzbsBlobUrl}/config/cpf/horoscope/config`;
        return BzbsApi.connectBzbsGetBlob(url);
    },
}
